// src/services/api.js
import axios from 'axios';

// Créer une instance Axios avec une configuration de base
const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000', 
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor pour gérer les réponses et détecter les erreurs d'authentification
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const originalRequest = error.config;

    if (
      error.response &&
      (error.response.status === 401 || error.response.status === 403) &&
      !originalRequest._retry // Ajouter cette condition pour éviter les doublons
    ) {
      // Vérifier si l'URL est celle de la connexion, pour ne pas afficher l'alerte
      if (originalRequest.url.includes('/api/users/login')) {
        return Promise.reject(error); // Retourner l'erreur sans alerte
      }

      // Autre cas : déclencher l'alerte d'expiration de session
      alert('Votre session a expiré ou vous devez vous reconnecter.');
      localStorage.removeItem('token'); // Supprimer le token
      window.location.href = '/login'; // Rediriger vers la page de connexion
    }

    return Promise.reject(error);
  }
);

export default api;